module.exports = __webpack_public_path__ + "img/avatar-5.1fe98e51.png";